import React from 'react';
import { BreadcrumbsState } from '@gumtree/shared/src/model/breadcrumbs.model';
import cx from 'classnames';
import Breadcrumb from './breadcrumb';
import BreadcrumbsSchema from './breadcrumbs-schema';
import BackLink from './back-link';

import './breadcrumbs.scss';

const Breadcrumbs: React.FC<BreadcrumbsState> = ({ backLink, links, className, canWrap = false }) => {
    return (
        <div className={cx('breadcrumbs-container', className)}>
            <BreadcrumbsSchema links={links} />
            {backLink && <BackLink href={backLink} />}
            <ol className={cx('breadcrumbs',{ 'canWrap': canWrap })}>
                {links.map((link, index) => (
                    <Breadcrumb key={link.name} index={index} {...link} />
                ))}
            </ol>
        </div>
    );
};

export default Breadcrumbs;
